import { notifyError, notifyNoAuth } from "./notificationHelper";
import { applicationState } from "@/states/applicationState";
import axios from "axios";
import { logOut } from "./oidcHelper";
import { Store } from "redux";

export const UnauthorizedStatusCode = 401;
export const ForbiddenStatusCode = 403;

export const setRequestInterceptor = (store: Store<applicationState>) => {
  axios.interceptors.request.use(
    (config) => {
      const user = store.getState().oidc.user;
      // Do something before request is sent
      if (user) {
        const accessToken = user.access_token;
        config.headers.Authorization = `Bearer ${accessToken}`;

        // TODO: Geçici olarak, userId header'da gönderiliyor.
        const userProfileId = store.getState().oidc.user!.profile.UserId;
        config.headers.UserId = userProfileId;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export const setResponseInterceptor = () => {
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response) {
        switch (error.response.status) {
          case UnauthorizedStatusCode:
            logOut();
            break;
          case ForbiddenStatusCode:
            notifyNoAuth();
            break;
          default:
            if (error.response.data.data && error.response.data.data.messages) {
              notifyError(error);
            }
            return Promise.reject(error);
        }
        return Promise.reject(error);
      }
      return Promise.reject(error);
    }
  );
};

export const setBaseUrl = (baseUrl: string) => {
  axios.defaults.baseURL = baseUrl;
};
